import { render } from "./ListingPhotos.vue?vue&type=template&id=189bd8a2"
import script from "./ListingPhotos.vue?vue&type=script&lang=js"
export * from "./ListingPhotos.vue?vue&type=script&lang=js"

import "./ListingPhotos.vue?vue&type=style&index=0&id=189bd8a2&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__